import { METABASE } from "../ApiManagement/apiServices"

export const PAGECODE = {
    "Accessibility Overview": 1,
    "USWDS and Design Standards": 2,
    "Vulnerability Scan Data(OWASP)": 3,
    "Search Engine Presence": 4,
    "Security Compliance": 5,
    "Mobile Compliance dashboard": 6,
    "Digital Analytics": 7,
    "Performance and Quality Data": 8,
    "Technology Stack Interface ": 9,
    "AI interpreter": 10,
    "User Management": 11,
    "Access Management": 12,
    "Site URL Summary": 13,
    "Add User": 14,
    "Mail Server": 15,
    "Scan List": 16,
    // "Add Site URL": 17,
    "Start A Scan": 17,
    "Organization": 18,
    "ReferranceTable": 19,
    "ComplianceDashboard": 20,
    "customReportLayout": 21,
    "Comprehensive Compliance Dashboard": 22,
    "ComplianceMapping": 23,
    "Newdashboard": 24,
    "Organization Dashboard": 26,
    "AI Hub": 27,
    "SSP Studio": 28,
    "SSP Studio New": 29,
    "Compliance Rules Admin": 30
}

// Map internal PAGECODE keys to user-facing display names
export const PAGEDISPLAYNAMES = {
    "Accessibility Overview": "Accessibility Overview",
    "USWDS and Design Standards": "US Web Design Standards",
    "Vulnerability Scan Data(OWASP)": "Vulnerability Scan Overview",
    "Search Engine Presence": "Search Engine Presence",
    "Security Compliance": "Security Compliance",
    "Mobile Compliance dashboard": "Mobile Compliance",
    "Digital Analytics": "Digital Analytics",
    "Performance and Quality Data": "Performance and Quality Data",
    "Technology Stack Interface ": "Technology Stack Interface",
    "AI interpreter": "AI interpreter",
    "User Management": "User Management",
    "Access Management": "Access Management",
    "Site URL Summary": "Site URL Summary",
    "Add User": "Add User",
    "Mail Server": "Mail Server",
    "Scan List": "Scan List",
    "Start A Scan": "Start A Scan",
    "Organization": "Organization",
    "ReferranceTable": "Upload Custom CSV",
    "ComplianceDashboard": "Compliance Dashboard",
    "customReportLayout": "Report customization",
    "Comprehensive Compliance Dashboard": "Comprehensive Compliance Dashboard",
    "ComplianceMapping": "Compliance Mapping",
    "Newdashboard": "Dashboard",
    "Organization Dashboard": "Organization Dashboard",
    "AI Hub": "AI Hub",
    "SSP Studio New": "SSP Studio",
    "Compliance Rules Admin": "Compliance Rules Admin"
}


export const PAGEPATHS = {
    ComprehensiveComplianceDashboard: "/comprehensiveCompliance",

    Login: '/login',
    Activation: '/activation',
    Register: '/register',
    Scanlist: '/scanlist',
    editOrganization: '/editOrganaization',
    referrancrTable: '/referranceTableCreate',
    customReportLayout: '/customReportLayout',
    ComplianceDashboard: '/complianceDashboard',
    CustomerDashbord: '/customerDashboard',
    Accessibility: '/accessibility',
    Searchengine: "/searchengine",
    Securitycomp: "/websecurity",
    Mobilecomp: "/mobilecompliance",
    Analytics: "/analytics",
    Performance: "/siteperformance",
    Technologystack: "/technology",
    AIinterpreter: "/aiinterpreter",
    Usermanage: "/usermanagement",
    Accessmanage: "/useraccess",
    Siteurlsummary: "/siteurlsummary",
    Adduser: "/adduser",
    Mailserver: "/mailserve",
    // Addsiteurl: "/addsiteurl",
    StartAScan: "/startascan",
    Forbidden: "/forbidden",
    Vulnerability: '/vulnerability',
    Uswebdesignstd: '/uswds',
    Logout: '/logout',
    Savedreportlist: "/Savedreportlist",
    FrameworkDetail: "/framework",
    DashboardOverview: "/DashboardOverview",
    ComplianceMapping: "/ComplianceMapping",
    Newdashboard: "/complianceReport",
    Dashboard: "/Dashboard",
    FrameworkDetails: "/FrameworkDetails",
    Generatetest: "/generatetest",
    Forget: '/forgetpassword',
    Reset: '/resetPassword',
    Internalerror: '/pages-500',
    Notfound: '*',
    Landing: '/',
    OrganizationDashboard: '/organization-dashboard',
    AIHub: '/ai-hub',
    Profile: '/profile',
    // SSPStudio: 'http://localhost:3500',
    HelpSupport: '/help',
    SSPStudio: '/ssp-studio',
    SSPStudioNew: '/ssp-studio-new',
    ComplianceAdmin: '/compliance-admin'
}

export const SIDEBARDATA = [
    { pageCode: 11, icon: <i className="mdi mdi-account-settings"></i>, route: PAGEPATHS.Usermanage, name: "User Management" },
    { pageCode: 12, icon: <i className="mdi mdi-account"></i>, route: PAGEPATHS.Accessmanage, name: "Access Management" },
    { pageCode: 14, icon: <i className="mdi mdi-account"></i>, route: PAGEPATHS.Adduser, name: "Add User" },
    { pageCode: 17, icon: <i className="mdi mdi-link"></i>, route: PAGEPATHS.StartAScan, name: "Start A Scan" },
    // { pageCode: 17, icon: <i className="mdi mdi-link"></i>, route: PAGEPATHS.Addsiteurl, name: "Add Site URL" },
    { pageCode: 18, icon: <i className="mdi mdi-link"></i>, route: PAGEPATHS.editOrganization, name: "Organization" },
    { pageCode: 19, icon: <i className="mdi mdi-link"></i>, route: PAGEPATHS.referrancrTable, name: "Upload Custom CSV" },
    { pageCode: 21, icon: <i className="mdi mdi-file-chart"></i>, route: PAGEPATHS.customReportLayout, name: "Report customization" },
    // { pageCode: 20, icon: <i className="mdi mdi-link"></i>, route:METABASE.adminRoute, name: "Create Custom Report" },
    { pageCode: 16, icon: <i className="mdi mdi-barcode-scan"></i>, route: PAGEPATHS.Scanlist, name: "Scan List" },
    { pageCode: 24, icon: <i className="mdi mdi-account"></i>, route: PAGEPATHS.Newdashboard, name: "Dashboard" },
    // { pageCode: 28, icon: <i className="mdi mdi-layers"></i>, route: PAGEPATHS.SSPStudio, name: "SSP STUDIO" },
    { pageCode: 29, icon: <i className="mdi mdi-shield-check"></i>, route: PAGEPATHS.SSPStudioNew, name: "SSP Studio" },
    { pageCode: 30, icon: <i className="mdi mdi-file-cog"></i>, route: PAGEPATHS.ComplianceAdmin, name: "Compliance Rules Admin" },
    // { pageCode: 13, icon: <i className="mdi mdi-book-open-variant"></i>, route: PAGEPATHS.Siteurlsummary, name: "Site URL Summary" },
    { pageCode: 1, icon: <i className="mdi mdi-human"></i>, route: PAGEPATHS.Accessibility, name: "Accessibility Overview" },
    { pageCode: 5, icon: <i className="mdi mdi-security"></i>, route: PAGEPATHS.Securitycomp, name: "Security Compliance" },
    { pageCode: 7, icon: <i className="mdi mdi-chart-line"></i>, route: PAGEPATHS.Analytics, name: "Digital Analytics" },
    { pageCode: 8, icon: <i className="mdi mdi-speedometer-medium"></i>, route: PAGEPATHS.Performance, name: "Performance and Quality Data" },
    { pageCode: 4, icon: <i className="mdi mdi-engine"></i>, route: PAGEPATHS.Searchengine, name: "Search Engine Presence" },
    { pageCode: 15, icon: <i className="mdi mdi-email-check"></i>, route: PAGEPATHS.Mailserver, name: "Mail Server" },
    { pageCode: 2, icon: <i className="mdi mdi-grid"></i>, route: PAGEPATHS.Uswebdesignstd, name: "US Web Design Standards" },
    { pageCode: 9, icon: <i className="mdi mdi-tools"></i>, route: PAGEPATHS.Technologystack, name: "Technology Stack Interface " },
    { pageCode: 3, icon: <i className="mdi mdi-shield-bug"></i>, route: PAGEPATHS.Vulnerability, name: "Vulnerability Scan Overview" },
    // { pageCode: 6, icon: <i className="mdi mdi-view-dashboard"></i>, route: PAGEPATHS.Mobilecomp, name: "Mobile Compliance" },
    // { pageCode: 10, icon: <i className="mdi mdi-vector-intersection"></i>, route: PAGEPATHS.AIinterpreter, name: "AI interpreter" },
    {
        pageCode: 23,
        icon: <i className="mdi mdi-map"></i>,
        route: PAGEPATHS.ComplianceMapping,
        name: "Compliance Mapping"
    },
    { pageCode: 26, icon: <i className="mdi mdi-account"></i>, route: PAGEPATHS.OrganizationDashboard, name: "Organization Dashboard" },
    // { pageCode: 27, icon: <i className="mdi mdi-brain"></i>, route: PAGEPATHS.AIHub, name: "AI Hub" },


]

// Get pages that should be displayed in Access Management for a user
// This ensures users only see permission settings for pages available to them
export const getAccessManagementPages = (userType, userPermissions) => {
    if (userType === USERTYPES.Standard) {
        // Standard users only see: Start A Scan (17), Scan List (16), Dashboard (24), SSP Studio (29)
        return [17, 16, 24, 29];
    } else if (userType === USERTYPES.Admin) {
        // Super admin sees default admin pages + granted permissions
        const allPages = new Set([...DEFAULTADMINPAGE, ...(userPermissions?.read || [])]);
        return Array.from(allPages);
    } else {
        // Organization/Global admin sees NOTSCANPAGE + Dashboard + granted permissions
        const allPages = new Set([...NOTSCANPAGE, 24, ...(userPermissions?.read || [])]);
        return Array.from(allPages);
    }
};

export const DEFAULTADMINPAGE = [11, 17, 24, 16, 18, 19, 20, 21, 23, 26, 27, 28, 29, 30]

export const NOTSCANPAGE = [11, 17, 16, 29]

export const DEFAULTUSERPAGE = [17, 16]

export const USERTYPES = {
    Admin: 'superadmin',
    Global: 'globaladmin',
    Organization: 'organizationadmin',
    Standard: 'standard'
}

export const USER_STATUS = {
    PendingEmail: 0,
    PendingApproval: 1,
    Active: 2,
    Disabled: 3
}
